import React from 'react';
import { Button, ButtonProps } from 'antd';
import './AccentButton.css';

/**
 * AccentButton
 * A specialized Button component that uses the 'accentBlueButton' theme token.
 * This ensures consistent blue background with white text for primary actions
 * like "Add Show" or "Add Band" in the sidebar.
 */
export default function AccentButton({ className, ...props }: ButtonProps) {
    return (
        <Button
            {...props}
            className={`accent-button ${className || ''}`}
        />
    );
}
